import React, { useCallback } from 'react';
import NextImage from 'next/image';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

var Image = function Image(_ref) {
  var image = _ref.image,
      _ref$preload = _ref.preload,
      preload = _ref$preload === void 0 ? false : _ref$preload;

  if (!image || !image.src) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  var contentfulAssetImageLoader = useCallback(function (_ref2) {
    var src = _ref2.src,
        width = _ref2.width,
        quality = _ref2.quality;

    if (src.indexOf('svg') !== -1) {
      return "".concat(src, "?fm=webp&q=", 65);
    }

    return src;
  }, []);
  var getImageSource = useCallback(function () {
    var src = image.src;

    if (src.startsWith('http')) {
      return src;
    }

    if (src.startsWith('data:')) {
      return src;
    }

    return "https:".concat(src);
  }, [image.src]);
  var defaultPlaceholder = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAE0lEQVR42mPsaeipZ0ADjDQQBAB6Mwp5QFYjhwAAAABJRU5ErkJggg==';
  return /*#__PURE__*/_jsx(NextImage, {
    alt: image.alt,
    src: getImageSource(),
    loader: contentfulAssetImageLoader,
    placeholder: "blur",
    blurDataURL: image.placeholder || defaultPlaceholder,
    width: image.width,
    height: image.height,
    priority: preload
  });
};

export default Image;